import { gql } from 'src/__generated__';

export const TRACK_JOB_APPLICATION_STARTED = gql(`
  mutation TrackJobApplicationStarted(
    $input: TrackJobApplicationStartedInput!
  ) {
    trackJobApplicationStarted(input: $input) {
      eventId
    }
  }
`);
